export const activeLanguages = [
  'en',
  'de',
  'ja',
  'es',
  'fr',
  'it',
  'id-ID',
  'pt-BR',
] as const;
const pendingLanguages = [] as const;

export const supportedLanguages = [
  ...activeLanguages,
  ...pendingLanguages,
] as const;

export type ActiveLanguage = typeof activeLanguages[number];
export type SupportedLanguage = typeof supportedLanguages[number];
